module.exports = __webpack_public_path__ + "img/8-3.b29df70d.png";